import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EditTrackPayload, TracksWithPagination } from '@shared/interfacres/track';

import { GetFilter, GetPagination } from '@shared/interfacres/request-related';
import { BaseApiService } from '@data-access/common/base-api.service';
import { environment } from '@env/environment';

@Injectable({providedIn: 'root'})
export class TracksManagerService extends BaseApiService {

  parseUrl = environment.apiParseUrl;

  getTracks(
    trackName: string,
    filter: GetFilter,
    pagination: GetPagination
  ): Observable<TracksWithPagination> {
    let apiUrl = `${this.apiUrl}/admin/library/tracks?page=${pagination.page}&limit=${pagination.pageSize}&sortBy=${filter.query}&sortDirection=${filter.order}`;
    if (trackName) {
      apiUrl += `&search=${trackName}`;
    }
    return this._httpClient.get<TracksWithPagination>(apiUrl).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    );
  }

  delete(ids: number[]) {
    const url = `${this.apiUrl}/admin/library/tracks`;
    return this._httpClient.delete(url, {body: {ids}}).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    );
  }

  setPosition(id: number, prevPosition: number | null, nextPosition: number | null) {
    const url = `${this.apiUrl}/admin/library/track/${id}/change-position`;
    return this._httpClient.post(url, {prevPosition, nextPosition}).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    );
  }

  getSignedTrackUrlById(id: number): Observable<{ url: string; waveform: number[][] | null }> {
    const requestUrl = `${this.parseUrl}/admin/library/signed-track-url/${id}`;
    return this._httpClient.get<{ url: string; waveform: number[][] | null }>(requestUrl);
  }

  getSignedTrackSampleUrlById(id: number) {
    const requestUrl = `${this.apiUrl}/library/track-sample/${id}`;
    return this._httpClient.get(requestUrl, {responseType: 'text'});
  }

  updatePartial(trackId: number, payload: Partial<EditTrackPayload>) {
    const url = `${this.apiUrl}/admin/library/track/${trackId}`;
    return this._httpClient.patch(url, payload).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    );
  }

  uploadFiles(files: File[]) {
      if (files.length === 0) {
      return; // No files selected
    }

    const formData = new FormData();
    for (const file of files) {
      formData.append('files', file, file.name);
    }

    const url = `${this.parseUrl}/admin/upload/parse-bulk`;
    return this._httpClient.post(url, formData, {
      reportProgress: true,
      observe: 'events'
    })

  }
  saveBulk(sessionId: string, tracks: Partial<EditTrackPayload>[]) {
    const url = `${this.apiUrl}/admin/upload/save-bulk`;
    return this._httpClient.post(url, {
      sessionId,
      tracks
    }).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    );

  }
}
